var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00003 8.88291L4.75837 12.1246C4.63614 12.2468 4.48892 12.3065 4.3167 12.3037C4.14448 12.301 3.99725 12.2385 3.87503 12.1162C3.75837 11.994 3.70142 11.8482 3.7042 11.6787C3.70698 11.5093 3.7667 11.3662 3.88337 11.2496L7.1167 7.99957L3.88337 4.74957C3.7667 4.63291 3.70837 4.48985 3.70837 4.32041C3.70837 4.15096 3.7667 4.00513 3.88337 3.88291C4.00003 3.76068 4.14448 3.69818 4.3167 3.69541C4.48892 3.69263 4.63614 3.75235 4.75837 3.87457L8.00003 7.11624L11.2417 3.87457C11.3639 3.75235 11.5111 3.69263 11.6834 3.69541C11.8556 3.69818 12.0028 3.76068 12.125 3.88291C12.2417 4.00513 12.2986 4.15096 12.2959 4.32041C12.2931 4.48985 12.2334 4.63291 12.1167 4.74957L8.88337 7.99957L12.1167 11.2496C12.2334 11.3662 12.2917 11.5093 12.2917 11.6787C12.2917 11.8482 12.2334 11.994 12.1167 12.1162C12 12.2385 11.8556 12.301 11.6834 12.3037C11.5111 12.3065 11.3639 12.2468 11.2417 12.1246L8.00003 8.88291Z",
    fill: "black",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.33cc3757580ce82bd057654a34b8376c.svg";
export { ForwardRef as ReactComponent };